import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useTranslations } from '@altermaind/core/i18n';
import { Asset, Box, Button, Typography } from '@altermaind/web/ui';
import { Routes, SuccessCodes } from '@/_shared/constants';
import { getModeTheme } from '@/_shared/styles/state/selectors';
import { useLogin } from '@/login/state';

type Props = {
  translationKey: keyof typeof SuccessCodes;
  onlyClose?: boolean;
};

export const FallbackSuccess: FC<Props> = ({ translationKey, onlyClose }) => {
  const t = useTranslations('successBoundary');
  const tGeneral = useTranslations('general');
  const mode = useSelector(getModeTheme());
  const { logout } = useLogin();

  const handleRedirectToLogin = () => {
    logout();
    if (onlyClose) {
      window.self.close();
      return;
    }
    window.location.href = Routes.Login;
  };

  return (
    <Box
      bg='primary/background'
      height='100vh'
      width='100vw'
      flexDirection='column'
      display='flex'
      alignItems='center'
    >
      <Box
        minHeight='100vh'
        display='flex'
        flex='0 0 auto'
        alignItems='center'
        justifyContent='center'
        flexDirection='column'
      >
        <Asset
          mb='xl'
          domain='images'
          name={mode === 'light' ? 'logoLight' : 'logoDark'}
          width='150'
        />
        <Typography variant='h2' mb='xxs'>
          {t(`title.${translationKey}`, { defaultValue: t('title.default') })}
        </Typography>
        <Typography variant='p2/light' mb='xs'>
          {t(`description.${translationKey}`, { defaultValue: t('description.default') })}
        </Typography>
        <Button mt='s' onClick={handleRedirectToLogin}>
          {tGeneral('goToLogin')}
        </Button>
      </Box>
    </Box>
  );
};
